import {appConfig} from '@stencil/hotels-config';
import parseDateIntoHermesString from './date-utils/parse-date-into-hermes-string';

const {defaultPartner} = appConfig;

const getDetailsPageUrl = ({
  hotelData = {},
  partner = defaultPartner,
  checkin,
  checkout,
  country = '',
  roomString,
  staticData = {},
  destination = {},
  filter = {},
  metaPartner = '',
  offerCode = '',
  appliedFilters = [],
}) => {
  const {ct = {}, xtr = {}, n: destinationCityName, t = ''} = destination;

  let cityName = destinationCityName;
  if (t === 'hotel' && staticData && Object.keys(staticData).length > 0) {
    cityName = staticData?.c;
  }

  const {cc = ''} = xtr;

  if (xtr && xtr.flt) {
    const {n: voyCityName = ''} = ct;
    cityName = voyCityName;
  }

  const {date: checkinDate} = checkin;
  const {date: checkoutDate} = checkout;
  let hmd = '',
    reviewtype = '';
  const {hn, hc, ibp = ''} = hotelData;
  if (hotelData.hmd) hmd = hotelData.hmd;

  const hName = hn.replace(/\//g, ' ').toLowerCase();
  let urlHname = hName.replace(/[^\w\s]/gi, '').split(' ');
  urlHname = urlHname.filter(el => {
    if (el !== '' && el !== 'hotel') {
      return true;
    }
  });

  urlHname = urlHname.join('-');
  if (hotelData.gri) reviewtype = hotelData.gri === 3 ? 'ta' : 'gi';
  const {hctx = '', sctx = []} = filter;
  const hotelContext = hctx ? `&hctx=${hctx}` : '';
  const subContext = sctx && sctx.length ? `&sctx=${sctx}` : '';
  const isMeta = metaPartner ? `&metaTraffic=${metaPartner}` : '';
  const isHmd = hmd ? `&hmd=${hmd}` : '';
  const isOfferCode = offerCode ? `&offerCode=${offerCode}` : '';
  const reviewType = reviewtype ? `&reviewType=${reviewtype}` : '';
  const hotelQueryString = JSON.stringify({
    ci: parseDateIntoHermesString(checkinDate),
    co: parseDateIntoHermesString(checkoutDate),
    r: roomString,
    ibp,
  });
  const appliedFiltersQueryParam =
    appliedFilters.length > 0 ? `&appliedFilters=${JSON.stringify(appliedFilters)}` : '';
  // TO:DO: fdwp param
  const ccQ = (country && `&cc=${country}`) || '';

  return `/${partner}/${urlHname}-hotel-in-${cityName}-${hc}/?hquery=${hotelQueryString}${hotelContext}${subContext}${isMeta}${isOfferCode}${isHmd}${ccQ}${appliedFiltersQueryParam}${reviewType}`;
};

export default getDetailsPageUrl;
